function formatNameWithInitials(fullName) {
	if (!fullName) return 'Unknown Nurse';

	const parts = fullName.trim().split(/\s+/);
	if (parts.length === 1) return parts[0]; // Just one name, return as is

	// Keep the first name as is
	const firstName = parts[0];

	// Map the rest to initials with a dot
	const initials = parts
		.slice(1)
		.map((name) => name[0].toUpperCase() + '.')
		.join(' ');

	return `${firstName} ${initials}`;
}

export { formatNameWithInitials };
